import { useAuth } from 'react-oidc-context';

// This controls presentation only. Every API command validates signed entitlements.
export function tokenPermissions(token?: string): string[] {
  try {
    const part = token?.split('.')[1];
    if (!part) return [];
    const payload: unknown = JSON.parse(atob(part.replaceAll('-', '+').replaceAll('_', '/')));
    if (!payload || typeof payload !== 'object' || !('entitlements' in payload)) return [];
    const values = payload.entitlements;
    return Array.isArray(values) ? values.filter((value): value is string => typeof value === 'string') : [];
  } catch { return []; }
}

export function usePermissions() {
  const { user } = useAuth();
  const permissions = tokenPermissions(user?.access_token);
  return (permission: string) => permissions.includes(permission) || permissions.includes('core:*') || permissions.includes('*');
}
